import React from "react";
import {
  CareersSelectionProcessCardContainer,
  CareersSelectionProcessCardParagraph,
  CareersSelectionProcessCardParagraphHeader,
  CareersSelectionProcessCardParagraphText,
  CareersSelectionProcessImage,
  Bold,
} from "./CareersSelectionProcessCardCricleImage.styled";
import SubSectionText from "components/SubSectionText/SubSectionText";
import { Trans } from "react-i18next";
import PropTypes from "prop-types";

const CareersSelectionProcessCardCricleImage = (props) => {
  return (
    <CareersSelectionProcessCardContainer>
      <CareersSelectionProcessCardParagraph $color={props.bgColor}>
        <CareersSelectionProcessImage $src={props.image} $height={"80px"}>
          {props.imageText && (
            <Trans i18nKey={props.imageText} components={[<Bold key={0} />]} />
          )}
        </CareersSelectionProcessImage>
        <CareersSelectionProcessCardParagraphHeader>
          <Trans i18nKey={props.header} components={[<Bold key={0} />]} />
        </CareersSelectionProcessCardParagraphHeader>

        {props.text && (
          <CareersSelectionProcessCardParagraphText>
            <SubSectionText text={props.text} textColor={"dark"} />
          </CareersSelectionProcessCardParagraphText>
        )}
      </CareersSelectionProcessCardParagraph>
    </CareersSelectionProcessCardContainer>
  );
};

CareersSelectionProcessCardCricleImage.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  text: PropTypes.string,
  header: PropTypes.string,
  bgColor: PropTypes.string,
  IsEvenRow: PropTypes.bool,
  imageText: PropTypes.string,
  textColor: PropTypes.string,
};

CareersSelectionProcessCardCricleImage.defaultProps = {
  textColor: "white",
  IsEvenRow: false,
};

export default CareersSelectionProcessCardCricleImage;
